import * as actionTypes from "./actionTypes";

const initialState = {
  isLoading: false,
  modules: [],
  collaboratorsList: [],
  menus: [],
  exclusions: [],
  moduleList: [],
  tree: [],
  resources: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.RESET_ALL:
      return initialState;

    case actionTypes.GET_MODULES:
      return { ...state, isLoading: true };
    case actionTypes.GET_MODULES_FULFILLED:
      return {
        ...state,
        isLoading: false,
        modules: action.payload.modules,
        collaboratorsList: action.payload.collaboratorsList,
        resources: action.payload.resources,
      };
    case actionTypes.GET_MODULES_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.UPDATE_MODULE:
      return { ...state, isLoading: true };
    case actionTypes.UPDATE_MODULE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        modules: action.payload.modules,
        resources: action.payload.resources,
      };
    case actionTypes.UPDATE_MODULE_REJECTED:
      return { ...state, isLoading: false };

    // menus
    case actionTypes.GET_MENUS:
      return { ...state, isLoading: true };
    case actionTypes.GET_MENUS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        menus: action.payload.menus,
        resources: action.payload.resources,
      };
    case actionTypes.GET_MENUS_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.UPDATE_MENU:
      return { ...state, isLoading: true };
    case actionTypes.UPDATE_MENU_FULFILLED:
      return {
        ...state,
        isLoading: false,
        menus: action.payload.menus,
        resources: action.payload.resources,
      };
    case actionTypes.UPDATE_MENU_REJECTED:
      return { ...state, isLoading: false };

    // exclusions
    case actionTypes.GET_EXCLUSIONS:
      return { ...state, isLoading: true };
    case actionTypes.GET_EXCLUSIONS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        exclusions: action.payload.exclusions,
        moduleList: action.payload.moduleList,
        collaboratorsList: action.payload.collaboratorsList,
        resources: action.payload.resources,
      };
    case actionTypes.GET_EXCLUSIONS_REJECTED:
      return { ...state, isLoading: false };
    case actionTypes.CREATE_EXCLUSIONS:
      return { ...state, isLoading: true };
    case actionTypes.CREATE_EXCLUSIONS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        exclusions: action.payload.exclusions,
        moduleList: action.payload.moduleList,
        collaboratorsList: action.payload.collaboratorsList,
        resources: action.payload.resources,
      };
    case actionTypes.CREATE_EXCLUSIONS_REJECTED:
      return { ...state, isLoading: false };
    case actionTypes.UPDATE_EXCLUSIONS:
      return { ...state, isLoading: true };
    case actionTypes.UPDATE_EXCLUSIONS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        exclusions: action.payload.exclusions,
        moduleList: action.payload.moduleList,
        collaboratorsList: action.payload.collaboratorsList,
        resources: action.payload.resources,
      };
    case actionTypes.UPDATE_EXCLUSIONS_REJECTED:
      return { ...state, isLoading: false };
    case actionTypes.DELETE_EXCLUSIONS:
      return { ...state, isLoading: true };
    case actionTypes.DELETE_EXCLUSIONS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        exclusions: action.payload.exclusions,
        moduleList: action.payload.moduleList,
        collaboratorsList: action.payload.collaboratorsList,
        resources: action.payload.resources,
      };
    case actionTypes.DELETE_EXCLUSIONS_REJECTED:
      return { ...state, isLoading: false };
    case actionTypes.DUPLICATE_EXCLUSIONS:
      return { ...state, isLoading: true };
    case actionTypes.DUPLICATE_EXCLUSIONS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        exclusions: action.payload.exclusions,
        moduleList: action.payload.moduleList,
        collaboratorsList: action.payload.collaboratorsList,
        resources: action.payload.resources,
      };
    case actionTypes.DUPLICATE_EXCLUSIONS_REJECTED:
      return { ...state, isLoading: false };

    // tree
    case actionTypes.GET_TREE:
      return { ...state, isLoading: true };
    case actionTypes.GET_TREE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        tree: action.payload.tree,
      };
    case actionTypes.GET_TREE_REJECTED:
      return { ...state, isLoading: false };

    default:
      return state;
  }
}
